import { useEffect } from "react";
import { useUserContext } from "context/UserContext";
import axios from "../api/axios";

const useAutoRefresh = () => {
  const { signIn, signOut, user } = useUserContext();

  useEffect(() => {
    const refreshAccessToken = () => {
      const expiresAt = parseInt(
        localStorage.getItem("accessTokenExpiresAt"),
        10
      );
      const refreshToken = localStorage.getItem("refreshToken");

      if (!expiresAt || !refreshToken) {
        console.warn("No expiresAt or refreshToken found.");
        return;
      }

      // Refresh if token or will expire in less than 1 minute
      if (Date.now() > expiresAt - 60 * 1000) {
        axios
          .post("/api/auth/refresh-token", { refreshToken })
          .then((res) => {
            if (!res?.data?.accessToken) {
              throw new Error("No token returned in refresh");
            }

            const newAccessToken = res.data.accessToken;
            const newExpiresAt = Date.now() + 15 * 60 * 1000;

            localStorage.setItem("token", newAccessToken);
            localStorage.setItem("accessTokenExpiresAt", newExpiresAt);

            signIn({
              user: res?.data?.seller || user?.info,
              token: newAccessToken,
              refreshToken,
            });
          })
          .catch((err) => {
            console.error("❌ Token refresh failed", err);
            signOut();
          });
      }
    };

    // ✅ Run immediately on mount
    refreshAccessToken();

    // ✅ Run every 1 minute
    const interval = setInterval(refreshAccessToken, 60 * 1000);

    return () => clearInterval(interval);
  }, []);
};

export default useAutoRefresh;
